<app-error-interceptor></app-error-interceptor>
<app-loader [isMobile]="isMobile"></app-loader>
<router-outlet [class.is-mobile]="isMobile" [class.is-desktop]="isDesktop"></router-outlet>

